export default class Course {
  constructor(API) {
    this.api = API;
  }
  async createCourse(certificationID, courseObj) {
    const req = await this.api.newBaseRequest('POST');
    req.path = `/certification/${certificationID}/course/new`;
    req.body = courseObj;
    return await req.exec();
  }
  async updateCourse(certificationID, courseObj) {
    const req = await this.api.newBaseRequest('PUT');
    req.path = `/certification/${certificationID}/course/${courseObj.id}`;
    req.body = courseObj;
    return await req.exec();
  }
  async deleteCourse(certificationID, courseID) {
    const req = await this.api.newBaseRequest('DELETE');
    req.path = `/certification/${certificationID}/course/${courseID}`;
    return await req.exec();
  }
  async getCourse(certificationID, courseID) {
    const req = await this.api.newBaseRequest('GET');
    req.path = `/certification/${certificationID}/course/${courseID}`;
    return await req.exec();
  }
  async getCourses(certificationID) {
    const req = await this.api.newBaseRequest('GET');
    req.path = `/certification/${certificationID}/courses`;
    return await req.exec();
  }
}
